import DeviceManagementScreen from './device-management-screen';

export default DeviceManagementScreen;
